<template>
    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
            <router-link class="nav-link" active-class="active" aria-current="page" to="/">Dashboard</router-link>
        </li>


        <li class="nav-item" v-if="user && [TipoUsuario.ADMINISTRADOR, TipoUsuario.MASTER].includes(user.tipo)">
            <router-link class="nav-link" active-class="active" aria-current="page" to="/lojas">Lojas</router-link>
        </li>

        <li class="nav-item" v-if="user && [TipoUsuario.ADMINISTRADOR, TipoUsuario.MASTER].includes(user.tipo)">
            <router-link class="nav-link" active-class="active" aria-current="page" to="/usuarios">Usuários</router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" active-class="active" aria-current="page" to="/consulta-precos">Consulta de Preços</router-link>
        </li>



    </ul>
</template>
<script setup lang="ts">
import { current_user as user } from "@/store/auth";
import { TipoUsuario } from "@/store/usuario";




</script>
